import axios from "axios";
import ContactImage from "../undraw_contact_us_15o2.svg";
import https from "https";

function Contact(props) {
  function checkEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  const checkData = (msg) => {
    if (msg.name !== "" && msg.email !== "" && msg.message !== "") {
      if (checkEmail(msg.email)) {
        return true;
      } else {
        alert("Email is not valid");
      }
    } else {
      return false;
    }
  };

  const sendForm = async (data, url) => {
    try {
      const response = await axios.post(url, data, {
        httpsAgent: new https.Agent({ keepAlive: true }),
      });
      return response;
    } catch (error) {
      throw error;
    }
    // console.log("message send", data);
  };

  const sendNetlifyForm = async (data) => {
    try {
      let newData = new URLSearchParams(data).toString();
      const response = await axios.post("/", newData, {
        httpsAgent: new https.Agent({ keepAlive: true }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      axios.post("");
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      });
      return true;
    } catch (error) {
      throw error;
    }
  };

  const onSubmit = async (event) => {
    try {
      event.preventDefault(); // Page reload remove

      const newForm = new FormData(event.target);
      const msg = {
        name: newForm.get("name"),
        email: newForm.get("email"),
        message: newForm.get("message"),
        secretMessage: "checking",
      };

      console.log(newForm, event.target);

      if (checkData(msg)) {
        // sendForm(msg, props.ContactFormUrl);
        // await sendNetlifyForm(msg);

        alert("Thanks for contacting us.");
        // window.location.reload(false);
      } else {
        if (checkEmail(msg.email)) {
          // return true;
          alert("Please fill all the fields");
        } else {
          alert("Email is not valid");
        }
      }
    } catch (error) {
      alert(error);
    }
  };

  // // TODO Fix form
  // return "";

  // Temprary disabled
  return (
    <div className="contact-section" id="contact">
      <div className="container flex">
        <div className="contact-form">
          <h1 className="special-heading">Contact</h1>
          <form
            name="contact"
            netlify
            netlify-honeypot="bot-field"
            onSubmit={onSubmit}
            // method="post"
            data-netlify-recaptcha="true"
          >
            <input type="hidden" name="form-name" value="contact" />
            <input type="text" placeholder="Full name" name="name" requried />
            <input type="hidden" value="real-form" name="checking" />
            <input type="email" placeholder="Email" name="email" requried />
            <textarea
              name="message"
              id="message"
              cols="30"
              rows="10"
              placeholder="Message"
            ></textarea>
            <div data-netlify-recaptcha="true"></div>
            <button type="submit">Submit</button>
          </form>
        </div>

        <div className="contact-image">
          <img src={ContactImage} alt="contactImage" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
